import apiClient from '../apiClient';

const BASE = '/reportes/anses';

// Reporte de turnos ANSES. Un solo endpoint que trae todo: la pantalla lo muestra junto y pedirlo
// por partes serían seis viajes para dibujar una misma vista.

/** @param desde/hasta ISO (yyyy-MM-dd). Sin fechas: últimos 6 meses + lo agendado. */
export async function obtenerReporteAnses({ desde, hasta } = {}) {
    const { data } = await apiClient.get(BASE, { params: { desde, hasta } });
    return data;
}
